import { UpcomingMatch } from "../../types/types";
import { MatchScheduleList } from "../shared/MatchSchedule";
import { ScheduleTeamFilter } from "./MatchPageFilters";
import { RoutePageMeta } from "../../seo/RoutePageMeta";
import { useSchedule } from "./hooks/useSchedule";

interface ScheduleGroupProps {
  label: string;
  matches: UpcomingMatch[];
}

const ScheduleGroup = ({ label, matches }: ScheduleGroupProps) => {
  return (
    <section className="schedule-page-group" aria-label={label}>
      <h2 className="home-section-title">{label}</h2>
      <MatchScheduleList
        matches={matches}
        mode="upcoming"
        hideMatchType
        className="schedule-list schedule-page-list"
      />
    </section>
  );
};

export const Schedule = () => {
  const {
    strings,
    loading,
    selectedTeamIds,
    teamsInSchedule,
    groups,
    toggleTeam,
    clearTeamFilter,
    hasUpcoming,
    filterActive,
  } = useSchedule();

  return (
    <section className="schedule-page">
      <RoutePageMeta page="SCHEDULE" />
      <div className="schedule-page-header">
        <h1 className="home-section-title">{strings.SCHEDULE.PAGE_TITLE}</h1>
        <p className="schedule-page-subtitle">{strings.SCHEDULE.PAGE_SUBTITLE}</p>
      </div>

      {!loading && hasUpcoming && (
        <ScheduleTeamFilter
          teams={teamsInSchedule}
          selectedTeamIds={selectedTeamIds}
          onToggleTeam={toggleTeam}
          onClear={clearTeamFilter}
        />
      )}

      {loading ? (
        <p className="schedule-page-status">{strings.SCHEDULE.LOADING}</p>
      ) : groups.length ? (
        <div className="schedule-page-groups">
          {groups.map((group) => (
            <ScheduleGroup key={group.key} label={group.label} matches={group.matches} />
          ))}
        </div>
      ) : (
        <div className="schedule-empty-card">
          <p className="schedule-empty-title">
            {filterActive && hasUpcoming
              ? strings.SCHEDULE.NO_FILTER_RESULTS
              : strings.NEWS.NO_UPCOMING_MATCHES}
          </p>
          <p className="schedule-empty-hint">
            {filterActive && hasUpcoming
              ? strings.SCHEDULE.NO_FILTER_RESULTS_HINT
              : strings.NEWS.SCHEDULE_EMPTY_HINT}
          </p>
        </div>
      )}
    </section>
  );
};
